import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "roate-text-content" }

import { computed, ref } from 'vue'
import { useWindowSize, useRect } from '@vant/use';


export default {
  __name: 'RoateText',
  props: {
  text: {
    type: String,
    default: 'Roate Text',
  },
  fontSize: {
    type: [Number, String],
    default: '20px',
  },
  radius: {
    type: [Number, String],
    default: '400px',
  },
  roateDirection: {
    type: String,
    default: 'up',
  }
},
  setup(__props) {

const { width, height } = useWindowSize();

const props = __props

const locale = ref('en');

const calFontSize = computed(() => {
  return Math.min(getVal(props.fontSize), 14);
})
const calRadius = computed(() => {
  return getVal(props.radius);
})

const calTransform = i => {
  const length = props.text.length; //字符串长度
  const rPosition = (length + 1) / 2 - i; //字符相对于 字符串中间点的位置
  const rWidth = rPosition * calFontSize.value * 0.8;
  const radian  = Math.asin(rWidth / calRadius.value);
  const angle = radian * 180 / Math.PI;
  const translateY = calRadius.value - Math.sqrt(Math.pow(calRadius.value,2) - Math.pow(rWidth,2))
  if (props.roateDirection === 'down') {
    return `translateY(-${Math.abs(translateY)}px) rotate(${angle}deg)`;
  } else if (props.roateDirection === 'up') {
    return `translateY(${translateY}px) rotate(${-angle}deg)`;
  }
}
const getVal = (val) => {
  let calValue;
  if (typeof val === 'number') {
    calValue = val;
  } else {
    calValue = parseFloat(val);
    if (val.indexOf('px') > -1) {
      calValue = calValue * width.value / 430;
    }
  }
  return calValue;
}

const letterWidth = (letter) => {
  let ratio = 0.8
  if (/^[MW]$/.test(letter)) {
    ratio = 1
  } else if (/^[I0-9 ]$/.test(letter)) {
    ratio = 0.7
  }
  return parseInt(calFontSize.value * ratio);
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (locale.value === 'en')
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.text.length, (i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            style: _normalizeStyle({
          width: /^[A-Za-z0-9 ]$/.test(__props.text[i-1]) ? `${letterWidth(__props.text[i-1])}px` : 'auto',
          lineHeight: `${calFontSize.value}px`,
          fontSize: `${calFontSize.value}px`,
          transform: calTransform(i),
        })
          }, _toDisplayString(__props.text[i-1]), 5))
        }), 128))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle({
        lineHeight: `${calFontSize.value + 2}px`,
        fontSize: `${calFontSize.value}px`
      })
        }, _toDisplayString(__props.text), 5))
  ]))
}
}

}